export function getPageCount(itemCount, itemsPerPage) {
  const safeItemCount = Number.isFinite(itemCount) && itemCount > 0 ? itemCount : 0;
  const safeItemsPerPage = Number.isFinite(itemsPerPage) && itemsPerPage > 0 ? itemsPerPage : 1;
  return Math.max(1, Math.ceil(safeItemCount / safeItemsPerPage));
}
